import { render, staticRenderFns } from "./DropTemplates.vue?vue&type=template&id=058a4b80"
import script from "./DropTemplates.vue?vue&type=script&lang=js"
export * from "./DropTemplates.vue?vue&type=script&lang=js"
import style0 from "./DropTemplates.vue?vue&type=style&index=0&id=058a4b80&prod&lang=scss"
import style1 from "./DropTemplates.vue?vue&type=style&index=1&id=058a4b80&prod&lang=scss"
import style2 from "./DropTemplates.vue?vue&type=style&index=2&id=058a4b80&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports